/** Conteúdo de páginas jurídicas estruturadas (legal_page.v1). */

const str = (v) => String(v ?? "").trim();
const strList = (v) => (Array.isArray(v) ? v.map((x) => str(x)).filter(Boolean) : []);

function parseMaybe(raw) {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
}

export function emptyLegalPage() {
  return sanitizeLegalPage({
    format: "legal_page.v1",
    meta: { title: "", description: "" },
    intro: "",
    secoes: [],
    disclaimer: "",
  });
}

export function sanitizeLegalPage(src) {
  const v = src && typeof src === "object" ? src : {};
  const metaIn = v.meta && typeof v.meta === "object" ? v.meta : {};

  const secoes = Array.isArray(v.secoes)
    ? v.secoes
        .map((s) => {
          const titulo = str(s?.titulo);
          const paragrafos = strList(s?.paragrafos);
          const itens = strList(s?.itens);
          if (!titulo && !paragrafos.length && !itens.length) return null;
          return { titulo, paragrafos, itens };
        })
        .filter(Boolean)
    : [];

  return {
    format: "legal_page.v1",
    meta: {
      title: str(metaIn.title),
      description: str(metaIn.description),
    },
    intro: str(v.intro),
    secoes,
    disclaimer: str(v.disclaimer) || undefined,
  };
}

export function parseLegalPageFromContent(contentData) {
  const raw = parseMaybe(contentData?.conteudo_json);
  if (raw?.format === "legal_page.v1") {
    return sanitizeLegalPage(raw);
  }
  return emptyLegalPage();
}
